import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Game} from "../Game";
import {gsap, TimelineMax} from "gsap";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {GameFeatureMode} from "../enums/Enum";
import {Sound} from "../sound/Sound";

export class IdleNormalPresentation implements FlowStatePresentation {
    private _tl: TimelineMax | undefined;
    private _idleTl: gsap.core.Timeline | null;
    private _idleFlickerTl: gsap.core.Timeline | null;
    private _isIdleAnimationPlaying: boolean = false;
    private _currentIdleSound: string = "";
    private _flowStateController: FlowStateController

    public start(flowStateController: FlowStateController) {
        this._flowStateController = flowStateController;
        if (Game.model.data?.nextMode != GameFeatureMode.NORMAL || Game.autoPlayPlugin.isAutoplayRound) {
            flowStateController.finish();
            return;
        }

        this._tl = new TimelineMax();
        flowStateController.setSkipCallback(() => this.skip(flowStateController));

        //Because the mental2 has Gamble enabled, you won't see any win toggeling. It was decided during BookOfShadow that no toggeling should happen if there was gamble involved.
        //Though if you play the game with Norsktipping or Germany jurisdiction it will function as normal because at the moment ow writing this Gamble is not allowed in those jurisdictions.


        if (Game.model.gameData?.betWayWins.length > 0 && !Game.model.gameData?.brokeTheBank) {
            if (Game.model.gameData && Game.model.gameData.betWayWins && !Game.autoPlayPlugin.isAutoplayRound && !Game.isWinBelowStake()) {
                let delay: number = 0;
                if (Game.totalWinView.showEndTl?.isActive()) {
                    delay = Game.totalWinView.showEndTl.totalDuration();
                }
                this._tl.delay(delay);
                this._tl.add(this.getToggleAnim(), 0);
            }
        } else {
            if (Game.model.gameData?.brokeTheBank) {
                Game.winWaysView.showToggleWinWaysItems(Game.model.gameData.accumulatedRoundWin, 0);
            }
            if (Game.model.data.nextMode.includes("NORMAL")) {
                this._tl.add(() => {
                    Game.soundPlayer.fadeSound(1, 0, 500);
                    Game.soundPlayer.fadeSound(0, 1, 500, Sound.IDLE_LOOP_MAIN);
                    Game.backgroundElements.clockReverse();
                    this.idleFlickerAnimation();
                    this.playIdleAnimation();
                }, Game.model.gameData ? 12 : 16);
            } else {
                flowStateController.finish();
            }
        }
        Game.buyFeatureName = "";
    }

    public skip(flowStateController?: FlowStateController): void {
        if (this._tl != undefined) {
            this._tl.kill();
            delete this._tl;
            this._flowStateController.finish();
        }
        // this._idleTl?.clear();
        if (Game.totalWinView.showEndTl?.isActive()) {
            Game.totalWinView.showEndTl.timeScale(20);
        }
        if (this._isIdleAnimationPlaying) {
            this._idleFlickerTl?.totalProgress(1);
            Game.backgroundElements.clockSetOnTime();
            Sound.IDLE_FLICKERS.forEach((flicker: string) => {
                Game.soundPlayer.stopSound(flicker);
            })
            Game.soundPlayer.stopSound(this._currentIdleSound);
            Game.soundPlayer.fadeSound(1, 0, 0.001, Sound.IDLE_LOOP_MAIN);
            Game.soundPlayer.fadeSound(0, 1, 0.001);
            this._isIdleAnimationPlaying = false;
        }
        this._idleTl?.kill();
        this._idleFlickerTl?.kill();
        Game.winHighlightView.reset();
        if (Game.reelView.alpha < 1) {
            Game.reelView.show();
        }
        Game.winWaysView.removeToggleWinWaysItems();
    }

    private idleFlickerAnimation(): void {
        const duration: number[] = [0.4667, 0.8333, 1.6667];
        let index: number = Math.floor(Math.random() * 3);

        if (this._idleFlickerTl) {
            this._idleFlickerTl.kill();
        }

        this._idleFlickerTl = gsap.timeline({
            onComplete: () => {
                this.idleFlickerAnimation();
            }
        })
        this._idleFlickerTl.add(() => {
            Game.soundPlayer.playSound(Sound.IDLE_FLICKERS[index]);
            Game.foregroundElements.playAndStopIdleFlicker(duration[index]);
        }, 0);
        this._idleFlickerTl.to(this, {duration: Math.ceil(Math.random() * 3 + 7)});
    }

    private playIdleAnimation(): void {
        const randomTime: number = Math.floor(Math.random() * 3 + 2);

        if (this._idleTl) {
            this._idleTl.kill();
        }

        this._idleTl = gsap.timeline({
            onComplete: () => {
                this.playIdleAnimation();
            }
        });
        this._idleTl.add(() => {
            this._isIdleAnimationPlaying = true;
        }, 0);

        this._idleTl.add(() => {
            this.playIdleTop();
        }, randomTime);

        this._idleTl.add(() => {
            Game.soundPlayer.stopSound(this._currentIdleSound);
        }, 12 + randomTime);
        this._idleTl.to(this, {duration: 2});
    }

    private getToggleAnim(): TimelineMax {
        const animName: string = (Game.model.winRatioConfig.duration > 0.001 ? "intenseFrame" : "frame");
        const duration: number = 0.8 * 2;
        const winGroup: IBetWayWinData[] = Game.model.data.betWayWins;
        let totalWaysToggle: number = 0;
        const tl: TimelineMax = new TimelineMax({
            repeat: -1,
            repeatDelay: duration - 0.4
        });
        tl.delay(0.5);
        winGroup.forEach((betWaysWin: IBetWayWinData, index: number) => {
            totalWaysToggle += betWaysWin.numberOfCombinations;
            const symbolAnim: gsap.core.Timeline = new gsap.core.Timeline();
            if (!Game.isWinBelowStake()) {
                symbolAnim.add(() => {
                    Game.winWaysView.showToggleWinWaysItems(betWaysWin.multipliedAmount, betWaysWin.numberOfCombinations);
                });
            }
            const reelWinPos: boolean[][][] | undefined = Game.model.reelWinPos.get(betWaysWin.symbol);
            if (reelWinPos) {
                reelWinPos.forEach((reels: boolean[][], reelId: number) => {
                    reels.forEach((splits: boolean[], rowId: number) => {
                        symbolAnim.add(Game.winHighlightView.play(reelId, rowId, animName, splits), 0);
                    });
                });
            }
            symbolAnim.add(() => {
                Game.winWaysView.fadeOutToggleWinWaysItems()
            });
            tl.add(symbolAnim, duration * index);
        });

        if (winGroup.length > 1) {
            const symbolAnim: gsap.core.Timeline = new gsap.core.Timeline();
            Game.model.gameData.allWinPos.forEach((reels: boolean[][], reelId: number) => {
                reels.forEach((splits: boolean[], rowId: number) => {
                    symbolAnim.add(Game.winHighlightView.play(reelId, rowId, animName, splits), 0);
                });
            });
            tl.add(symbolAnim, duration * winGroup.length);
            if (!Game.isWinBelowStake()) {
                tl.add(() => {
                    Game.winWaysView.showToggleWinWaysItems(Game.model.gameData.totalSpinWinnings, totalWaysToggle);
                }, duration * winGroup.length);
            }
            tl.add(() => Game.winWaysView.fadeOutToggleWinWaysItems());
        }
        return tl;
    }

    private playIdleTop(): void {
        if (!Sound.IDLE_LOOP_TOPS.length) {
            Sound.IDLE_LOOP_TOPS = ["idleLoopTop1", "idleLoopTop2", "idleLoopTop3", "idleLoopTop4"];
            Sound.IDLE_LOOP_TOPS = Sound.IDLE_LOOP_TOPS.filter(soundPlaying => soundPlaying !== this._currentIdleSound);
        }
        this._currentIdleSound = Game.soundPlayer.playRandomSoundWithoutRepeat(Sound.IDLE_LOOP_TOPS);
    }
}